import {Icon} from 'antd'

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_918540_jhok2o0z388.js',
});
IconFont.pre = 'menu'
export default IconFont